import { useContext } from 'react';
import { WebsiteContext } from '../utils/WebsiteContext';
export var useWebsite = function useWebsite() {
  return useContext(WebsiteContext);
};